import type { LegacyMatch, TournamentResponse } from "../api/legacyTypes";
import { EntityLink } from "./EntityLink";
import { LocalDateTime } from "./LocalDateTime";

type Props = {
  matches: LegacyMatch[];
  teams: TournamentResponse["tournament"]["teams"];
};

export function ApexScheduleGrid({ matches, teams }: Props) {
  const teamByID = new Map(teams.map((team) => [team.id, team]));
  return <div className="match-grid schedule-grid apex-schedule-grid">{matches.map((match) => {
    const details = match.apex;
    const leader = details?.standings[0];
    const team = leader ? teamByID.get(leader.teamId) : undefined;
    const stage = match.bracket || "Lobby series";
    const champion = stage === "Finals" && match.status === "completed";
    return <article className="match-card apex-schedule-card" key={match.sourceKey}>
      <header><div><span className="eyebrow">{stage}</span><h3>{match.round}</h3></div><span className={`status status-${match.status}`}>{match.status}</span></header>
      <div className="apex-schedule-facts"><strong>{details?.standings.length ?? 0} squads</strong><span>{details?.games.length ?? 0} games</span>{details?.matchPointThreshold ? <span>Match Point · {details.matchPointThreshold}</span> : null}</div>
      {leader && <div className="apex-schedule-leader"><span>{champion ? "Champion" : "Series leader"}</span><EntityLink gameId="apexlegends" kind="team" name={leader.team} entityId={leader.teamId} logoUrl={team?.logoUrl || (leader.teamId ? `/media/organization/${leader.teamId}` : "")} /><strong>{leader.totalPoints} pts</strong></div>}
      <LocalDateTime value={match.startsAt} status={match.status} />
    </article>;
  })}</div>;
}
